var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},_vm._l((_vm.year_range),function(year){return _c('div',{staticClass:"year"},[_vm._v("\n        "+_vm._s(year)+" - "+_vm._s(_vm.year_count[year])+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }